<script>
  import editorInstance from '../../lib/editor/editor';
  import PalleteSelection from './Modules/PalleteSelection/PalleteSelection.svelte';
  import ModuleBlock from './Modules/ModuleBlock.svelte';
  import LogoSidebar from './Modules/Logo/LogoSidebar.svelte';
  import FontsModule from './Modules/Fonts/FontsModule.svelte';
  import {getInstance} from '../../services/animation';
  import editorStore from '../../lib/editor/editor.store';
  import TextAi from './Modules/TextAI/TextAI.svelte';

  function selectVideoClip() {
    const clip = getInstance().templateLoader.getAmElement('sermonclip');
    editorStore.setActiveComponent(clip);
  }

  const components = [
    {
      // title: 'Colors',
      component: {
        component: PalleteSelection,
        args: {
          editorInstance
        }
      },
      expandable: false,
      open: true,
      nobg: true
    },
    {
      // title: 'Colors',
      component: TextAi,
      expandable: false,
      open: true,
      nobg: true
    },
    {
      // title: 'Colors',
      component: FontsModule,
      expandable: false,
      open: true,
      nobg: true
    },
    {
      // title: 'Logo',
      component: {
        component: LogoSidebar
        // args: {
        //   src: 'http://via.placeholder.com/640x360',
        // },
      },

      expandable: false,
      open: true,
      nobg: true
    }
  ];
</script>

<div class="px-4">
  {#each components as component}
    <ModuleBlock {...component} />
  {/each}
</div>

<!-- <div class="px-4">
  {#each advancedComponents as component}
    <ModuleBlock {...component}/>
  {/each}
</div> -->
